export const ChecklistAnswerInitializeMode = {
	NotSelected: 0,
	NewAnswer: 1,
	Reused: 2,
} as const;

export type ChecklistAnswerInitializeMode =
	(typeof ChecklistAnswerInitializeMode)[keyof typeof ChecklistAnswerInitializeMode];

export type ChecklistAnswerInitializeParams = {
	answerId: number;
	body: {
		answerToken: string;
		initializeMode: ChecklistAnswerInitializeMode;
	};
};
